module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9532.fbbf821e.jpg";